import { render } from "./index.vue?vue&type=template&id=e10ce8f0"
const script = {}

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__